import {
  createContext,
  Dispatch,
  SetStateAction,
  useEffect,
  useState
} from "react";
// import { useLocalStorage } from "../shared/local-storage-hook";
import Cookies from "js-cookie";
import { RootShowType } from "../models/home-rows";
import {
  Province,
  SuggestedAvatar,
  WeeklyTopSearch
} from "../models/home-rows";
import { LinkgProduct } from "../models/linkg";
import { Profile } from "../models/login";
import { RootCategoryModel } from "../models/root-category.model";
import { SubscribePackages } from "../modules/subscription/models/subscribe-packages";
import { useLocalStorage } from "./local-storage-services";
import { ROUTES } from "./router-services";

export const COOKIE_TOKEN_KEY = "token";
export const COOKIE_REFRESH_TOKEN_KEY = "refresh_token";
export const COOKIE_CLEAR = "";
const COOKIE_DG_ID = "dg_id";
const VERY_LONG_TIME = 10000;

export const isValidToken = (token: string) => token && token.length > 10;

interface Auth {
  isIosDigijoon: boolean;
  setIsIosDigijoon: (isIos: boolean) => void;
  weeklyTopSearch: WeeklyTopSearch | null;
  setWeeklyTopSearch: (weeklyTopSearch: WeeklyTopSearch) => void;
  recentlyUserSearch: WeeklyTopSearch | null;
  searchCategories: RootCategoryModel[];
  setSearchCategories: (searchCategories: RootCategoryModel[]) => void;
  setRecentlyUserSearch: (recentlyUserSearch: WeeklyTopSearch) => void;
  rootCategories: RootCategoryModel[];
  setRootCategories: (rootCategories: RootCategoryModel[]) => void;
  recentSearch: string[];
  setRecentSearch: (tags: string[]) => void;
  closeSearchModal: boolean;
  setCloseSearchModal: (modal: boolean) => void;
  showLoginPopup: boolean;
  setShowLoginPopup: (showLoginPopup: boolean) => void;
  showLoginByGoogle: boolean;
  setShowLoginByGoogle: (showLoginPopup: boolean) => void;
  loginMessage: string;
  setLoginMessage: (msg: string) => void;
  discountPackages: SubscribePackages;
  setDiscountPackages: (discountPackages: SubscribePackages) => void;
  token: string;
  dg_id: string;
  setDgId: (dgId: string) => void;
  fcm_token: string;
  setFcmToken: (fcmToken: string) => void;

  adminToken: string;
  refreshToken: string;
  // attempts: number,
  // referrer: string,
  // phoneMoment: string,
  // selectedHomeTitleIndex: number,

  setAdminToken: (token: string) => void;
  // setAttempts: (count: number) => void,

  // setReferrer: (ref: string) => void,
  // setPhoneMoment: (phoneMoment: string) => void,
  // setSelectedHomeTitleIndex: (index: number) => void,
  isAdmin: () => boolean;
  isSSR: boolean;
  setIsSSR: Dispatch<SetStateAction<boolean>>;
  linkgProducts: LinkgProduct[];
  setLinkgProducts: (products: LinkgProduct[]) => void;
  rootShowType: RootShowType[];
  setRootShowType: (rootShowType: RootShowType[]) => void;

  showFixedSearch: boolean;
  setShowFixedSearch: Dispatch<SetStateAction<boolean>>;

  showInstallBox: boolean;
  setShowInstallBox: Dispatch<SetStateAction<boolean>>;

  urlBeforeNavigateTOSubscription: string;
  setUrlBeforeNavigateTOSubscription: (ref: string) => void;

  referrer: string;
  phoneMoment: string;
  setReferrer: (ref: string) => void;
  setPhoneMoment: (phoneMoment: string) => void;
  // setSelectedHomeTitleIndex: (index: number) => void,
  profile?: Profile;
  setProfile: (profile: Profile) => void;

  provinces?: Province[];
  setProvinces: (provinces: Province[]) => void;

  suggestedAvatars: SuggestedAvatar[];
  setSuggestedAvatars: (suggestedAvatars: SuggestedAvatar[]) => void;

  debugLock: boolean;
  setDebugLock: (debugLock: boolean) => void;

  login: (token: string, refreshToken: string, dg_id: string) => void;
  logout: () => void;
  silentLogout: () => void;
  isLoggedIn: boolean;
  isIntlUser: boolean | null;
  isFirstLogin: boolean;
  setIsFirstLogin: (isFirstLogin: boolean) => void;
  isPersonalization: boolean;
  setIsPersonalization: (isPersonalization: boolean) => void;
  syncStateTokens: () => void;
  redirectPathAfterBuySub: string;
  setRedirectPathAfterBuySub: (ref: string) => void;
}

const initialAuth: Auth = {
  isIosDigijoon: false,
  setIsIosDigijoon: isios => {},
  isFirstLogin: false,
  setIsFirstLogin(isFirstLogin) {},
  isPersonalization: false,
  setIsPersonalization(isPersonalization) {},
  showFixedSearch: false,
  setShowFixedSearch: show => {},

  showInstallBox: true,
  setShowInstallBox: show => {},
  weeklyTopSearch: {
    products: [],
    categories: []
  },
  setWeeklyTopSearch: weeklyTopSearch => {},
  recentlyUserSearch: {
    products: [],
    categories: []
  },
  closeSearchModal: false,
  setCloseSearchModal: () => {},
  searchCategories: [],
  setSearchCategories: searchCategories => {},
  setRecentlyUserSearch: recentlyUserSearch => {},
  rootCategories: [],
  setRootCategories: rootCategories => {},
  recentSearch: ["عنوان اول", "عنوان دوم", "عنوان سوم"],
  setRecentSearch: tags => {},
  token: "",
  adminToken: "",
  refreshToken: "",
  dg_id: "",
  setDgId: dgId => {},
  fcm_token: "",
  setFcmToken: fcmToken => {},

  // attempts: 0,
  // referrer: "",
  // phoneMoment: "",
  // selectedHomeTitleIndex: -1,
  // setPhoneMoment: (phoneMoment) => {},
  referrer: "",
  setReferrer: ref => {},
  urlBeforeNavigateTOSubscription: "",
  setUrlBeforeNavigateTOSubscription: url => {},
  phoneMoment: "",
  setPhoneMoment: phoneMoment => {},
  setAdminToken: token => {},
  profile: undefined,
  setProfile: (profile: Profile) => {},
  provinces: [],
  setProvinces: provinces => {},
  suggestedAvatars: [],
  // setAttempts: (count) => {},
  // setReferrer: (ref) => {},
  // setSelectedHomeTitleIndex: (index) => {},
  isAdmin: () => false,
  isSSR: false,
  setIsSSR: is_ssr => {},
  linkgProducts: [],
  setLinkgProducts: linkgProducts => {},
  rootShowType: [],
  setRootShowType: rootShowType => {},
  debugLock: false,
  showLoginPopup: false,
  setShowLoginPopup: showLoginPopup => {},
  showLoginByGoogle: true,
  setShowLoginByGoogle: showLoginByGoogle => {},
  loginMessage: "",
  setLoginMessage: msg => {},
  setDebugLock: (debugLock: boolean) => {},
  setSuggestedAvatars: suggestedAvatars => {},
  discountPackages: {
    headers: [],
    product_packages: [],
    grouped_packages: [],
    footers: []
  },
  setDiscountPackages: (discountPackages: SubscribePackages) => {},

  logout: () => {},
  silentLogout: () => {},
  login: () => {},
  isLoggedIn: false,
  isIntlUser: null,
  syncStateTokens: () => {},
  redirectPathAfterBuySub: "",
  setRedirectPathAfterBuySub: path => {}
};

const AppContext = createContext(initialAuth);

export function AppContextProvider(props: any) {
  const [weeklyTopSearch, setWeeklyTopSearch] =
    useState<WeeklyTopSearch | null>(null);
  const [recentlyUserSearch, setRecentlyUserSearch] =
    useState<WeeklyTopSearch | null>(null);
  const [searchCategories, setSearchCategories] = useState([]);
  const [rootCategories, setRootCategories] = useState<RootCategoryModel[]>([]);
  const [showFixedSearch, setShowFixedSearch] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showLoginByGoogle, setShowLoginByGoogle] = useState(true);
  const [loginMessage, setLoginMessage] = useState("");
  const [loginReferrer, setLoginReferrer] = useState("");
  const [token, setToken] = useState("");
  const [refreshToken, setRefreshToken] = useState("");
  const [dg_id, set_dg_id] = useState("");
  const [isSSR, setIsSSR] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isIntlUser, setIsIntlUser] = useState(null);
  const [isFirstLogin, setIsFirstLogin] = useState(false);
  const [isPersonalization, setIsPersonalization] = useState(false);
  const [closeSearchModal, setCloseSearchModal] = useState(false);
  const { storedValue: localKeyword, setValue: setLocalKeyword } =
    useLocalStorage("keyword", "");
  const { storedValue: localAdminToken, setValue: setLocalAdminToken } =
    useLocalStorage("ADMIN_TOKEN", "");

  const [linkgProducts, setLinkgProducts] = useState<LinkgProduct[]>([]);
  const [rootShowType, setRootShowType] = useState<RootShowType[]>([]);
  const [debugLock, setDebugLock] = useState(false);
  const [provinces, setProvinces] = useState<Province[]>([]);
  const [urlBeforeNavigateTOSubscription, setUrlBeforeNavigateTOSubscription] =
    useState("");
  const [redirectPathAfterBuySub, setRedirectPathAfterBuySub] = useState("");
  const [isIosDigijoon, setIsIosDigijoon] = useState(false);
  const [suggestedAvatars, setSuggestedAvatars] = useState<SuggestedAvatar[]>(
    []
  );
  const [discountPackages, setDiscountPackages] = useState<SubscribePackages>({
    headers: [],
    product_packages: [],
    grouped_packages: [],
    footers: []
  });
  const [showInstallBox, setShowInstallBox] = useState(true);
  const { storedValue: phoneMoment, setValue: setPhoneMoment } =
    useLocalStorage("phoneMoment", "");
  const { storedValue: localProfile, setValue: setLocalProfile } =
    useLocalStorage("profile", "");
  const { storedValue: localFcmToken, setValue: setLocalFcmToken } =
    useLocalStorage("fcm_token", "");
  const { storedValue: localActiveSubs, setValue: setLocalActiveSubs } =
    useLocalStorage("active_subs", "");

  const [signalLogout, setSignalLogout] = useState(false);

  const syncStateTokens = () => {
    const tk = Cookies.get(COOKIE_TOKEN_KEY);
    const rftk = Cookies.get(COOKIE_REFRESH_TOKEN_KEY);
    const dgid = Cookies.get(COOKIE_DG_ID);
    //console.log(">>>syncStateTokens: ", token);
    tk && setToken(tk);
    rftk && setRefreshToken(rftk);
    dgid && set_dg_id(dgid);
    const tmpIsLoggedIn = tk && tk.length > 10;
    setIsLoggedIn(tmpIsLoggedIn);
    setIsIntlUser(
      !tmpIsLoggedIn && process.env.NEXT_PUBLIC_INTERNATIONAL === "yes"
    );
  };

  const silentLogout = () => {
    //console.log("setSignalLogout(true);");
    Cookies.set(COOKIE_TOKEN_KEY, COOKIE_CLEAR);
    Cookies.set(COOKIE_REFRESH_TOKEN_KEY, COOKIE_CLEAR);
    // Cookies.set(COOKIE_DG_ID, COOKIE_CLEAR);
    setToken("");
    setRefreshToken("");
    // set_dg_id(null);
    setIsLoggedIn(false);
    setIsFirstLogin(false);
    setIsPersonalization(false);
    setIsIntlUser(process.env.NEXT_PUBLIC_INTERNATIONAL === "yes");
    setLocalProfile("");
  };

  useEffect(() => {
    if (!signalLogout) return;
    silentLogout();
    const timeout = setTimeout(() => {
      if (window.location.pathname === ROUTES.root) {
        //console.log("reload...");
        window.location.reload();
      } else {
        //console.log("load root...");
        window.location.href = ROUTES.root;
      }
    }, 500);

    return () => clearTimeout(timeout);
  }, [signalLogout]);

  const authCtx: Auth = {
    isIosDigijoon,
    setIsIosDigijoon: isios => setIsIosDigijoon(isios),
    isFirstLogin,
    setIsFirstLogin: isFirstLogin => setIsFirstLogin(isFirstLogin),
    isPersonalization,
    setIsPersonalization: isPersonalization =>
      setIsPersonalization(isPersonalization),
    showFixedSearch,
    setShowFixedSearch: show => {
      setShowFixedSearch(show);
      //console.log("REQUEST_TO: " + (show ? "OPEN" : "CLOSE"));
    },
    searchCategories,
    setSearchCategories: searchCategories => {
      setSearchCategories(searchCategories);
    },
    showInstallBox,
    setShowInstallBox,
    closeSearchModal,
    setCloseSearchModal(modal) {
      setCloseSearchModal(modal);
    },
    weeklyTopSearch,
    setWeeklyTopSearch: weeklyTopSearch => {
      setWeeklyTopSearch(weeklyTopSearch);
    },
    recentlyUserSearch,
    setRecentlyUserSearch: recentlyUserSearch => {
      setRecentlyUserSearch(recentlyUserSearch);
    },
    rootCategories,
    setRootCategories: rootCategories => {
      setRootCategories(rootCategories);
    },
    discountPackages,
    setDiscountPackages: discountPackages => {
      setDiscountPackages(discountPackages);
    },
    recentSearch: localKeyword
      .replace(/["'\[\]]/g, "")
      .split(",")
      .filter(i => i.length > 0),
    setRecentSearch: tags => setLocalKeyword(tags.toString()),
    token,
    adminToken: localAdminToken,
    refreshToken,
    dg_id,
    setDgId: dgId => {
      set_dg_id(dgId || "");
      Cookies.set(COOKIE_DG_ID, dgId || "", { expires: VERY_LONG_TIME }); //expires in 10000 days
    },
    fcm_token: localFcmToken,
    setFcmToken: fcmToken => setLocalFcmToken(fcmToken),
    // attempts: authAttempts,
    // referrer: loginReferrer,
    // phoneMoment: phoneMoment,
    // selectedHomeTitleIndex: localSelectedHomeTitleIndex,
    // setPhoneMoment: (phoneMoment) => setPhoneMoment(phoneMoment),
    setAdminToken: token => setLocalAdminToken(token),
    // setAttempts: (attempts) => setAuthAttempts(attempts),
    // setReferrer: (ref) => setLoginReferrer(ref),
    // setSelectedHomeTitleIndex: (index) => setLocalSelectedHomeTitleIndex(index),
    linkgProducts,
    setLinkgProducts: products => {
      setLinkgProducts(products);
    },
    rootShowType: rootShowType,
    setRootShowType: rootShowType => setRootShowType(rootShowType),

    urlBeforeNavigateTOSubscription: urlBeforeNavigateTOSubscription,
    setUrlBeforeNavigateTOSubscription: url =>
      setUrlBeforeNavigateTOSubscription(url),
    redirectPathAfterBuySub: redirectPathAfterBuySub,
    setRedirectPathAfterBuySub: path => setRedirectPathAfterBuySub(path),
    // attempts: authAttempts,
    phoneMoment: phoneMoment,
    // selectedHomeTitleInisIntlUserex: localSelectedHomeTitleIndex,
    setPhoneMoment: phoneMoment => setPhoneMoment(phoneMoment),

    referrer: loginReferrer,
    setReferrer: ref => setLoginReferrer(ref),
    // setAttempts: (attempts) => setAuthAttempts(attempts),
    // setSelectedHomeTitleIndex: (index) => setLocalSelectedHomeTitleIndex(index),
    profile: localProfile ? JSON.parse(localProfile) : null,
    setProfile: profile => setLocalProfile(JSON.stringify(profile)),
    provinces,
    setProvinces,
    suggestedAvatars,
    setSuggestedAvatars,
    debugLock,
    setDebugLock,
    showLoginPopup,
    setShowLoginPopup: show => {
      setShowLoginPopup(show);
    },
    showLoginByGoogle,
    setShowLoginByGoogle: show => setShowLoginByGoogle(show),
    loginMessage,
    setLoginMessage: msg => setLoginMessage(msg),
    isAdmin: () => localAdminToken?.length > 0,
    isSSR,
    setIsSSR,

    logout: () => setSignalLogout(true),
    login: (token: string, refreshToken: string, dg_id: string) => {
      token && setToken(token);
      refreshToken && setRefreshToken(refreshToken);
      dg_id && set_dg_id(dg_id);
      const tmpIsLoggedIn: boolean = token?.length > 10;
      setIsLoggedIn(tmpIsLoggedIn);
      setIsIntlUser(
        !tmpIsLoggedIn && process.env.NEXT_PUBLIC_INTERNATIONAL === "yes"
      );
      Cookies.set(COOKIE_TOKEN_KEY, token, { expires: VERY_LONG_TIME });
      Cookies.set(COOKIE_REFRESH_TOKEN_KEY, refreshToken, {
        expires: VERY_LONG_TIME
      });
      Cookies.set(COOKIE_DG_ID, dg_id || "", { expires: VERY_LONG_TIME });
    },
    silentLogout,
    isLoggedIn,
    isIntlUser,

    syncStateTokens
  };

  return (
    <AppContext.Provider value={authCtx}>{props.children}</AppContext.Provider>
  );
}

export default AppContext;
